import { render, staticRenderFns } from "./InitialsPortrait.vue?vue&type=template&id=84d2b99a&scoped=true&"
import script from "./InitialsPortrait.vue?vue&type=script&lang=js&"
export * from "./InitialsPortrait.vue?vue&type=script&lang=js&"
import style0 from "./InitialsPortrait.vue?vue&type=style&index=0&id=84d2b99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d2b99a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
